const buildValidUrlRegex = (protocol: string) =>
  `^(${protocol})://.*$|^\\$\\{config\\.[A-Za-z0-9_]+(?:\\.[A-Za-z0-9_]+){0,999}\\}$`;
export const REGEX_VALID_HTTP_URL = buildValidUrlRegex('http|https');
export const REGEX_PROXY = buildValidUrlRegex('http');
export const REGEX_SECURE_PROXY = buildValidUrlRegex('https');
export const REGEX_CONFIG_PROP = `^\\$\\{config\\.[A-Za-z0-9_]+(?:\\.[A-Za-z0-9_]+){0,999}\\}$`;
